<template>
    <base-modal v-model="isVisible" @shown="loadProfAndCentersAuthorized">
        <paginated-table :fields="profAndCenterAuthorized.fields" :items="profAndCenterAuthorized.data" :empty-text="$t('noDataProfAndCenterAuthorized')">
            <template v-slot:cell(remove)="data" v-if="!$route.query.h">
                <span class="revoke-access" v-if="data.item.canDecline" @click.prevent="revokeAccess(data)" v-html="$t('revokeAccess')"></span>
            </template>
        </paginated-table>
    </base-modal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal'
import ClinicHistoryRepository from '../../repositories/ClinicHistoryRepository'
import PaginatedTable from '@/components/base/PaginatedTable'
import i18nMixin from '@/mixins/i18n.mixin'

const I18N_FILE = 'clinic-history'

export default {
    components: {
        BaseModal,
        PaginatedTable
    },
    props: {
        value: Boolean
    },
    mixins: [i18nMixin(I18N_FILE)],
    data () {
        return {
            profAndCenterAuthorized: {
                data: [],
                loading: true,
                fields: [
                    {
                        label: this.$t('name-column'),
                        key: 'nombre'
                    },
                    {
                        label: '',
                        key: 'remove'
                    }
                ]
            }
        }
    },
    created () {
    },
    computed: {
		isVisible: {
            get () {
                return this.value
            },
            set (val) {
                this.$emit('input', val)
            }
        }
	},
    methods: {
        loadProfAndCentersAuthorized (refresh) {
            if (this.profAndCenterAuthorized.data.length === 0 || refresh) {
                ClinicHistoryRepository().getProfessionalsAndCentersSharedClinic().then(result => {
                    if (result.data.data) {
                        this.profAndCenterAuthorized.data = result.data.data
                        this.profAndCenterAuthorized.loading = false
                    }
                })
            }
        },
        revokeAccess (data) {
            ClinicHistoryRepository().deleteProfessionalsAndCentersSharedClinic(data.item.id).then(response => {
                let data = response.data.data
                if (data) {
                    if (data === 0) {
                        this.$store.dispatch('showDangerAlert', this.$t('revokeAccessClinic.error'))
                    } else if (data === 1) {
                        this.$store.dispatch('showDangerAlert', this.$t('revokeAccessClinic.owner'))
                    } else if (data === 2) {
                        this.$store.dispatch('showDangerAlert', this.$t('revokeAccessClinic.withAppointment'))
                    } else if (data === 4) {
                        this.$store.dispatch('showDangerAlert', this.$t('revokeAccessClinic.center'))
                    } else {
                        this.$store.dispatch('showSuccessAlert', this.$t('revokeAccessClinic.success'))
                        this.loadProfAndCentersAuthorized(true)
                    }
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.revoke-access {
    cursor: pointer;
    color: $red;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/HistoryProfAndCenterAuthorized.vue